import React from 'react';
import { ContentListDownloadDataStyled } from './styles';

export interface Props {
  children: React.ReactNode;
}

export default function ContentListDownloadData({ children }: Props) {
  return (
    <ContentListDownloadDataStyled>{children}</ContentListDownloadDataStyled>
  );
}
